enum TimeZoneSourceType {
	COMPANY = 'COMPANY',
	JOB = 'JOB',
	WORK_ORDER = 'WORK_ORDER'
}

export const TimeZoneSourceTypeLabel: { [key in keyof typeof TimeZoneSourceType]: string; } = {
	[TimeZoneSourceType.COMPANY]: 'Company Location',
	[TimeZoneSourceType.JOB]: 'Job Location',
	[TimeZoneSourceType.WORK_ORDER]: 'Work Location',
};

export default TimeZoneSourceType;
